<script>
import appConfig from '@/app.config'
import TeamTaskDetail from '../../components/teamtask/index'
export default {
  page: {
    title: 'جزییات تیم تسک',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    TeamTaskDetail,
  },
  data() {
    return {
      title: 'جزییات درخواست محمدرضا کرمانشاهی',
      items: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'جزییات تیم تسک',
          active: true,
        },
      ],
    }
  },
}
</script>
<template>
    <TeamTaskDetail />
</template>

<style scoped lang="scss">
</style>
